import React from 'react';
import { 
  Box, Paper, Typography, Avatar, Divider, 
  List, ListItem, ListItemText, ListItemIcon 
} from '@mui/material';
import { Person, Email, Phone, Badge } from '@mui/icons-material';
import { authService } from '../services/authService';

const Profile = () => {
  // 1. Pull the user data we saved via authService
  const userData: any = authService.getUser() || {};

  // Helper to get initials for the large avatar
  const getInitials = (name?: string) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        User Profile
      </Typography>

      <Paper elevation={3} sx={{ p: 4, borderRadius: 3, textAlign: 'center' }}>
        {/* Profile Header */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
          <Avatar 
            sx={{ 
              width: 100, 
              height: 100, 
              bgcolor: 'primary.main', 
              fontSize: '2.5rem',
              mb: 2,
              boxShadow: 3
            }}
          >
            {getInitials(userData.name || 'User')}
          </Avatar>
          <Typography variant="h5" fontWeight="bold">
            {userData.name || 'Not Available'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {userData.role || 'Warehouse Personnel'}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Profile Details List */}
        <List>
          <ListItem>
            <ListItemIcon>
              <Badge color="primary" />
            </ListItemIcon>
            <ListItemText 
              primary="Full Name" 
              secondary={userData.name || 'N/A'} 
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <Email color="primary" />
            </ListItemIcon>
            <ListItemText 
              primary="Email Address" 
              secondary={userData.email || 'N/A'} 
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <Phone color="primary" />
            </ListItemIcon>
            <ListItemText 
              primary="Phone Number" 
              secondary={userData.phone || 'N/A'} 
            />
          </ListItem>
        </List>

        <Box sx={{ mt: 2, p: 2, bgcolor: '#fff9c4', borderRadius: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Note: Your profile details are managed by the Administrator and cannot be edited.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default Profile;